<template>
  <div class="tour-visit">
    <p v-if="withIds && visit.shipping_ids">
      ID/s: <strong v-for="(id, index) in visit.shipping_ids" :key="index">
        <b-link :to="{name: 'ShippingsEdit', params: {id}}" target="_blank">{{ id }}</b-link>
        <a href="#" @click.prevent="copyToClipboard(id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a><span v-if="(index + 1) < visit.shipping_ids.length">, </span>
      </strong>
    </p>
    <p
      v-translate="{type: this.$gettext(visit.type), n: visit.shipping_ids.length}"
      :translate-n="visit.shipping_ids.length"
      translate-plural="Type: <strong>%{type} multiple (%{ n } shippings)"
      class="m-0"
    >
      Type: <strong>%{type}</strong>
    </p>
    <p class="m-0" v-translate="{address: visit.address_name}">Address: <strong>%{address}</strong></p>
    <p class="m-0" v-if="visit.address_extra" v-translate="{addressExtra: visit.address_extra}">Address Extra: <strong>%{addressExtra}</strong></p>
    <p class="mt-3" v-translate="{visited: visit.visited === 1 ? this.$gettext('YES') : this.$gettext('NO')}">Visited: <strong>%{visited}</strong></p>
  </div>
</template>

<script>
export default {
  name: 'TourVisit',
  props: {
    visit: {
      type: Object,
      default: () => {},
      required: true
    },
    withIds: {
      type: Boolean,
      default: false
    }
  }
}
</script>
